import React from "react";

export const pretty = (text: string) =>
    text
        .replace(/_distribution$/, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

export const listify = (arr: string[], conjunction: string = "and") =>
    arr.length <= 1
        ? arr.join("")
        : arr.length === 2
        ? arr.join(` ${conjunction} `)
        : `${arr.slice(0, -1).join(", ")} ${conjunction} ${
              arr[arr.length - 1]
          }`;

export const FormattedText = ({ text }: { text: string }) => {
    return (
        <div>
            {text.split("\n\n").map((paragraph: string, idx: number) => (
                <p key={`p-${paragraph.substring(0, 20)}-${idx}`}>
                    {paragraph}
                </p>
            ))}
        </div>
    );
};
